<template>
  <div>
    <!-- <div class="my-3 input-group">
      <div class="input-group-prepend">
        <span class="input-group-text" id="filter">
          <i class="fa fa-search"></i>
        </span>
      </div>
      <input
        v-model.trim="filter"
        class="form-control"
        aria-describedby="filter"
        placeholder="filter by name"
      />
    </div>-->
    <div class="text-center">
      <button
        tag="button"
        class="btn"
        @click="onCheckout"
        :disabled="!nodesInCart.length"
      >Update Cart and Checkout</button>
    </div>
    <loading-panel :loading="loading" class="m-auto">
      <div v-if="!pending.length && !owned.length && !accesses.length">No locations found.</div>
      <div v-if="pending.length > 0">
        <h4>Pending Locations (created by you)</h4>
        <div v-for="(location, ind) in pending" :key="`${ind}_ploc`">
          <LocationDropdown :location="location" />
        </div>
      </div>
      <div v-if="owned.length > 0" :class="pending.length ? 'mt-4' : ''">
        <h4>Company Locations</h4>
        <div v-for="(location, ind) in owned" :key="`${ind}_oloc`">
          <LocationDropdown :location="location" />
        </div>
      </div>
      <div v-if="accesses.length > 0" :class="owned.length || pending.length ? 'mt-4' : ''">
        <h4>Vendor Access</h4>
        <div v-for="(location, ind) in accesses" :key="`${ind}_oloc`">
          <LocationDropdown :location="location" />
        </div>
      </div>
      <div class="text-center">
        <button
          tag="button"
          class="btn my-3"
          @click="onCheckout"
          :disabled="!nodesInCart.length"
        >Update Cart and Checkout</button>
      </div>
    </loading-panel>
    <error-panel class="m-auto" :errors="errors"></error-panel>
  </div>
</template>

<script>
import LocationDropdown from "@/components/purchase/LocationDropdown.vue";

export default {
  name: "purchase-list",
  components: {
    LocationDropdown
  },
  data: () => ({
    loading: true,
    errors: [],
    filteredLocations: [],
    filter: ""
  }),
  methods: {
    matchesFilter(location) {
      return location.title.toLowerCase().includes(this.filter.toLowerCase());
    },
    onCheckout() {
      let json = JSON.stringify(this.nodesInCart);
      this.$storage.write("cart", json);
      this.$router.push("/purchase/checkout");
    }
  },
  computed: {
    nodesInCart() {
      let nodes = [];
      let allLocations = this.$store.state.purchase.list;
      allLocations.forEach(location => {
        // For each node type, cycle through all nodes
        for (let i = 0; i < this.$consts.purchaseableNodeTypes.length; i++) {
          let nodeType = this.$consts.purchaseableNodeTypes[i];
          let typeInt = this.$consts.NODE_TYPE_STR_TO_INT[nodeType];

          for (let j = 0; j < location.nodes[typeInt].length; j++) {
            let node = location.nodes[typeInt][j];
            if (node.selected) nodes.push(node);
          }
        }
      });
      return nodes;
    },
    locations() {
      return this.$store.state.purchase.list;
    },
    owned() {
      return this.$store.state.purchase.list.filter(
        location => location.type === "owned" && this.matchesFilter(location)
      );
    },
    pending() {
      return this.$store.state.purchase.list.filter(
        location => location.type === "pending" && this.matchesFilter(location)
      );
    },
    accesses() {
      return this.$store.state.purchase.list.filter(
        location => location.type === "access" && this.matchesFilter(location)
      );
    }
  },
  async mounted() {
    try {
      await this.$store.dispatch("loadLocationsWithAllNodes");
      this.$storage.writeObject(
        "checkout-options",
        this.$store.state.purchase.checkoutOptions
      );

      // Get the nodes in the cart, and select them
      var cartJson = this.$storage.read("cart");

      // Select nodes using the cached cart
      if (cartJson) {
        let cachedCart = JSON.parse(cartJson);

        let allLocations = this.$store.state.purchase.list;
        allLocations.forEach(location => {
          // For each node type, cycle through all nodes
          for (let i = 0; i < this.$consts.purchaseableNodeTypes.length; i++) {
            let nodeType = this.$consts.purchaseableNodeTypes[i];
            let typeInt = this.$consts.NODE_TYPE_STR_TO_INT[nodeType];

            for (let j = 0; j < location.nodes[typeInt].length; j++) {
              let node = location.nodes[typeInt][j];
              if (
                cachedCart.some(cartNode => cartNode.node.id === node.node.id)
              ) {
                node.selected = true;
              }
            }
          }
        });
      }
    } catch (err) {
      console.log(err);
      this.errors = ["An error occurred."];
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
.btn:disabled,
.btn[disabled="disabled"] {
  background-color: #aaa;
  cursor: default;

  box-shadow: none;

  &:hover {
    background-color: #aaa;
  }
}
</style>